<template>
  <div class="sql-editor">
    <textarea ref="codeMirror"></textarea>
  </div>
</template>

<script>
// 核心样式
import "codemirror/lib/codemirror.css";
import "codemirror/addon/hint/show-hint.css";
import "codemirror/addon/hint/show-hint.js";
import "codemirror/addon/selection/active-line.js";
import "codemirror/addon/edit/matchbrackets.js";
import "codemirror/addon/hint/sql-hint.js";
import "codemirror/mode/sql/sql";
import "codemirror/mode/javascript/javascript";

// fold
import "codemirror/addon/fold/foldgutter.css";
import "codemirror/addon/fold/foldcode";
import "codemirror/addon/fold/foldgutter";
import "codemirror/addon/fold/brace-fold";
import "codemirror/addon/fold/comment-fold";

import CodeMirror from "codemirror";
export default {
  name: "SQLCodeMirror",
  props: {
    value: {
      type: String,
      default: ""
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      sqlEditor: null,
      code: ""
    };
  },
  mounted() {
    this.init();
    this.setSize();
  },
  methods: {
    init() {
      this.sqlEditor = CodeMirror.fromTextArea(this.$refs.codeMirror, this.options);
      this.setValue();
      this.editorEvents();
    },
    setValue(sql) {
      this.sqlEditor.setValue(sql || this.value);
    },
    setSize(width = "auto", height = "350px") {
      this.sqlEditor.setSize(width, height);
    },
    setHintOptions(tables) {
      this.sqlEditor.options.hintOptions.tables = tables;
    },
    editorEvents() {
      // 设置代码提示
      this.sqlEditor.on("keyup", (cm, event) => {
        if (event.keyCode >= 65 && event.keyCode <= 90){
          cm.showHint();
        }
        //所有的字母和'$','{','.'在键按下之后都将触发自动完成  
        if (!cm.state.completionActive &&  
          ((event.keyCode >= 65 && event.keyCode <= 90) || event.keyCode == 52 || event.keyCode == 219 || event.keyCode == 190)) {  
          CodeMirror.commands.autocomplete(cm, null, {completeSingle: false});  
        }
      });

      // 代码输入的双向绑定
      this.sqlEditor.on("change", (editor) => {
        // 这里要用多一个载体去获取值,不然会重复赋值卡顿
        this.code = editor.getValue();
        if (this.$emit) {
          this.$emit("input", this.code);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
